/** The agency's saved report themes. Shapes mirror apps/api/src/theme-routes.ts. */

import { apiCall, orgPath } from '../api.ts';
import type { ReportTheme } from './report-theme.ts';

export interface SavedTheme {
  id: string;
  name: string;
  theme: ReportTheme;
  updated_at: string;
}

const themes = (org: string, path = '') => orgPath(org, `/reports/themes${path}`);

export const themesApi = {
  list: (org: string) => apiCall<{ themes: SavedTheme[] }>(themes(org)).then((data) => data.themes),
  save: (org: string, name: string, theme: ReportTheme) =>
    apiCall<{ theme: SavedTheme }>(themes(org), {
      method: 'POST',
      body: JSON.stringify({ name, theme }),
    }).then((data) => data.theme),
  remove: (org: string, id: string) =>
    apiCall<{ deleted: boolean }>(themes(org, `/${id}`), { method: 'DELETE' }),
};
